import { render } from "./InspectionList.vue?vue&type=template&id=137263d7"
import script from "./InspectionList.vue?vue&type=script&lang=js"
export * from "./InspectionList.vue?vue&type=script&lang=js"

import "./InspectionList.vue?vue&type=style&index=0&id=137263d7&lang=css"
script.render = render

export default script